import { render, staticRenderFns } from "./UserProfileButton.vue?vue&type=template&id=6758a0a8&"
import script from "./UserProfileButton.vue?vue&type=script&lang=js&"
export * from "./UserProfileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports